import { ButtonLoader } from "../../components/Button"
import { ModalGeneratePDF } from "../ESMDetailsScreen"

const BeneficiaryEsmScreen = ({
  scaleId,
  scalesUser,
  scope,
  actionPlan,
  loadingActionPlan,
  handleOpenGenerateEsmBeneficiary,
  handleCloseGenerateEsmBeneficiary,
  openGenerateEsmBeneficiary,
}) => {
  return (
    <>
      <ButtonLoader
        label="Gerar Relatório Esm"
        variant="ghost"
        handleClick={handleOpenGenerateEsmBeneficiary}
        classButton={"historico"}
        isDisabled={!scaleId}
        loading={loadingActionPlan}
        messageProcess="Gerando pdf..."
      />
      {openGenerateEsmBeneficiary && (
        <ModalGeneratePDF
          {...{
            modalIsOpenGeneratePDF: openGenerateEsmBeneficiary,
            closeModal: handleCloseGenerateEsmBeneficiary,
            esmId: scaleId,
            projectId: scope?.id,
            esmData: scalesUser,
            actionPlan: actionPlan,
            barometerData: scalesUser,
          }}
        />
      )}
    </>
  )
}

export default BeneficiaryEsmScreen
